
export type AudienceType = 'visitor' | 'registered' | 'member' | 'expired member' | 'staff' | 'engineer' | 'auto';
export type AudienceFilter = (AudienceType | `-${AudienceType}` | 'all')[];

export function matchesAudience(type: AudienceType, filter: AudienceFilter) {
    if (!filter)
        return true;

    if (filter.includes('all'))
        return !filter.includes(`-${type}`);

    return filter.includes(type);
}

export const AUDIENCE_TYPES: {
    id: AudienceType,
    label: string,
    friendlyLabel: string
}[] = [
    { id: 'visitor', friendlyLabel: 'Signed Out', label: 'Visitor' },
    { id: 'registered', friendlyLabel: 'Signed into Free Account', label: 'Registered User' },
    { id: 'member', friendlyLabel: 'Signed in as Member', label: 'Member' },
    { id: 'expired member', friendlyLabel: 'Signed in as Expired Member', label: 'Expired Member' },
    { id: 'staff', friendlyLabel: 'Signed in as Staff', label: 'Staff' },
]